import React from "react"
import {t} from "@lingui/core/macro"
import styles from "./styles.module.css"

export default function Pagination({page, totalPages, onChange}) {
    if (totalPages <= 1) return null

    const pages = []
    const add = (p) => pages.push(p)
    const addEllipsis = () => pages.push("...")

    add(1)
    if (page > 4) addEllipsis()
    for (let p = Math.max(2, page - 2); p <= Math.min(totalPages - 1, page + 2); p++) {
        add(p)
    }
    if (page < totalPages - 3) addEllipsis()
    if (totalPages > 1) add(totalPages)

    return (
        <div className={styles.pagination}>
            <button
                className={styles.pageBtn}
                onClick={() => onChange(page - 1)}
                disabled={page <= 1}
                type="button"
            >
                {t`Précédent`}
            </button>
            {pages.map((p, idx) => p === "..." ? (
                <span key={`e-${idx}`} className={styles.pageEllipsis}>…</span>
            ) : (
                <button
                    key={p}
                    type="button"
                    className={`${styles.pageBtn} ${p === page ? styles.pageBtnActive : ""}`}
                    onClick={() => onChange(p)}
                >
                    {p}
                </button>
            ))}
            <button
                className={styles.pageBtn}
                onClick={() => onChange(page + 1)}
                disabled={page >= totalPages}
                type="button"
            >
                {t`Suivant`}
            </button>
        </div>
    )
}
